import storage from '../../utils/storage.js';
import localhost from '../../utils/localhost.js';
import axios from 'axios';
import md5 from 'js-md5'
const userLogin = {
  state: {
    loginMessage: null,
    userId: 0,
    userRoleMessage: null, // 用户相应角色的相关信息
    roles: null,
    appId: ''
  },
  mutations: {
    appIdUpdate (state, data) {
      state.appId = data;
    },
    loginUpdate (state, data) {
      if (!data.remember) {
        data.password = '';
      }
      storage.set('LoginMessage', data);
      state.loginMessage = data;
    },
    UserMessageUpdate (state, data) {
      state.userId = data.userId ? data.userId : 0;
      var roleMessage = [];
      for(var i in data) {
        if (typeof data.roleList === 'object' && data.roleList.length > 0
          && data.roleList.find(role => { return role == i})) {
          var item = data[i];
          item.rolenumber = i;
          roleMessage.push(item);
        }
      }
      state.userRoleMessage = roleMessage;
    },
    UserRolesUpdate (state, data) {
      if (typeof data === 'object' && data.length > 0) {
        state.roles = data.map(item => {return getRoleName(item)});
      } else {
        state.roles = [];
      }
    }
  },
  actions: {
    doUserLogin: function ({commit}, data) {
      var self = this;
      var params = new URLSearchParams();
      params.append('username', data.account);
      params.append('password', md5(data.password));

      return new Promise(function (resolve, reject) {
        axios.post(localhost.ajaxurl + '/user/auth/login', params)
          .then((res) => {
            if (!res.data.success) {
              reject('登录失败');
            } else {
              commit('UserRolesUpdate', res.data.data.roleList); // 记录用户角色表
              commit('loginUpdate', data); // 处理记住密码或者自动登录
              commit('UserMessageUpdate', res.data.data); // 记录用户登陆后的信息


              var userMessage = self.state.userLogin.userRoleMessage;
              var itemRole = userMessage.filter(item => {
                return item.rolenumber === '13';
              });
              if (itemRole && itemRole.length > 0) {
                var appId = itemRole[0].appId ? itemRole[0].appId : '';
              }
              localStorage.setItem('appId', appId);
              commit('appIdUpdate', appId);
              resolve();
            }
          }).catch((err) => {
          reject(err);
        })
      });
    },
    doUserLogout: function ({commit}, data) {
      commit('UserRolesUpdate', []);
    }
  },
  getters: {}
};

export default userLogin;

function getRoleName (role) {
  role = typeof role === 'number' ? role : Number(role);
  var name = '';
  switch (role) {
    case 1: name = 'common'; break; // 普通用户
    case 2: name = 'student'; break; // 学生
    case 3: name = 'develop'; break; // 开发者
    case 4: name = 'teacher'; break; // 老师
    case 5: name = 'parent'; break; // 家长
    case 6: name = 'demo'; break;
    case 7: name = 'organization'; break; // 机构
    case 8: name = 'agent'; break; // 代理
    case 9: name = 'distribution'; break; // 分销
    case 10: name = 'activity'; break; // 活动方
    case 11: name = 'community'; break; // 社区
    case 12: name = 'supercommunity'; break;
    case 13: name = 'distributionmanager'; break;
  }
  return name;
}



// WEBPACK FOOTER //
// ./src/vuex/modules/userLogin.js